import React from 'react'
import { Path } from 'react-native-svg'
import styled from 'styled-components/native'

import { AccessibleSvg } from 'ui/svg/AccessibleSvg'
import { AccessibleIcon } from 'ui/svg/icons/types'

const BookClubCertificationSvg: React.FunctionComponent<AccessibleIcon> = ({
  size,
  color,
  accessibilityLabel,
  testID,
}) => {
  return (
    <AccessibleSvg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      testID={testID}
      accessibilityLabel={accessibilityLabel}>
      <Path
        d="M22.8437 10.2991L23.4687 8.30169L21.7812 7.05332V4.96229L19.7812 4.30689L19.125 2.30949H17.0312L15.7812 0.624187L13.7812 1.24837L12.0312 0L10.3125 1.21716L8.3125 0.592978L7.0625 2.27828H4.96875L4.3125 4.27568L2.3125 4.93108V7.02211L0.625 8.27048L1.25 10.2679L0 12.0156L1.21875 13.7321L0.59375 15.7295L2.28125 16.9779V19.0689L4.28125 19.7243L4.9375 21.7217H7.03125L8.28125 23.407L10.2813 22.7828L12 24L13.7187 22.7828L15.7187 23.407L16.9688 21.7217H19.0625L19.7187 19.7243L21.7187 19.0689V16.9779L23.4063 15.7295L22.7812 13.7321L24 12.0156L22.8437 10.2991Z"
        fill={color}
      />
      <Path
        d="M15.7471 17.2656C15.747 17.3173 15.7379 17.3448 15.7305 17.3574C15.723 17.3699 15.7151 17.3802 15.7002 17.3877C15.6627 17.4102 15.5873 17.4277 15.4648 17.4277H7.92773C7.69273 17.4277 7.5 17.2602 7.5 17.0527C7.5 16.8452 7.69273 16.6777 7.92773 16.6777H15.7471V17.2656ZM9 16.25H7.875C7.74001 16.25 7.6125 16.28 7.5 16.335V7.5C7.5 6.9475 7.9475 6.5 8.5 6.5H9V16.25ZM15.7471 6.5C16.1596 6.5 16.4971 6.8375 16.4971 7.25V15.25C16.4971 15.7175 16.1771 16.1023 15.7471 16.2148V16.25H9.54492V6.5H15.7471ZM11.4971 10.75C11.3597 10.7502 11.2471 10.8626 11.2471 11C11.2471 11.1374 11.3597 11.2498 11.4971 11.25H13.4971C13.6346 11.25 13.7471 11.1375 13.7471 11C13.7471 10.8625 13.6346 10.75 13.4971 10.75H11.4971ZM11.4971 9.5C11.3597 9.50019 11.2471 9.61262 11.2471 9.75C11.2471 9.88738 11.3597 9.99981 11.4971 10H14.4971C14.6346 10 14.7471 9.8875 14.7471 9.75C14.7471 9.6125 14.6346 9.5 14.4971 9.5H11.4971Z"
        fill="white"
      />
    </AccessibleSvg>
  )
}

export const BookClubCertification = styled(BookClubCertificationSvg).attrs(
  ({ color, size, theme }) => ({
    color: color ?? theme.designSystem.color.icon.default,
    size: size ?? theme.designSystem.size.icon.l,
  })
)``
